import RailHoverBubble from '@/shared/components/RailHoverBubble/RailHoverBubble'
import useRailHoverLabel from '@/shared/components/RailHoverBubble/useRailHoverLabel'
import useRightPanelToggle from './useRightPanelToggle'
import { PanelToggleButton, PanelToggleIcon } from './styled-components'

const RightPanelToggle = () => {
  const { anchorRef, geometry, show, hide } = useRailHoverLabel<HTMLButtonElement>()
  const { expanded, showsCross, onToggle, Icon, iconColor, label } = useRightPanelToggle(anchorRef)

  return (
    <>
      <PanelToggleButton
        ref={anchorRef}
        type='button'
        data-panel-toggle
        $expanded={expanded}
        aria-expanded={showsCross}
        aria-label={label}
        onClick={onToggle}
        onMouseEnter={show}
        onMouseLeave={hide}
        onFocus={show}
        onBlur={hide}
      >
        <PanelToggleIcon key={String(showsCross)}>
          <Icon size={20} color={iconColor} />
        </PanelToggleIcon>
      </PanelToggleButton>
      <RailHoverBubble geometry={geometry} label={label} side='left' />
    </>
  )
}

export default RightPanelToggle
